import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

userListUsersTableStyles.usernameHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
        span {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        word-break: keep-all;
                    `,
                    css`
                        word-break: keep-all;
                    `,
                    css`
                        word-break: keep-all;
                    `,
                    null,
                    null,
                ])};
        }
    `,
};
userListUsersTableStyles.nameHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
        span {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        word-break: keep-all;
                    `,
                    css`
                        word-break: keep-all;
                    `,
                    css`
                        word-break: keep-all;
                    `,
                    null,
                    null,
                ])};
        }
    `,
};
userListUsersTableStyles.emailHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
    `,
};
userListUsersTableStyles.statusHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
    `,
};
userListUsersTableStyles.roleHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
    `,
};
userListUsersTableStyles.lastSignInHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            white-space: nowrap;
        }
    `,
};

userListUsersTableStyles.dataTable = {
    css: css`
        border-left: 1px solid ${getColor("common.border")};
    `,
};
userListUsersTableStyles.usernameCells = {
    css: css`
        text-align: center;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.link")};
            font-weight: 400;
            &:hover {
                text-align: center;
                text-decoration-line: underline;
                text-decoration-color: ${getColor("text.link")};
            }
        }
    `,
};
userListUsersTableStyles.emailCells = {
    css: css`
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
    `,
};
userListUsersTableStyles.statusCells = {
    css: css`
        color: ${getColor("text.main")} !important;
    `,
};
userListUsersTableStyles.roleCells = {
    css: css`
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
    `,
};
userListUsersTableStyles.lastSignInCells = {
    css: css`
        color: ${getColor("text.main")} !important;
    `,
};
